import styled from 'styled-components';
import Container from 'components/Container';
import { P, H2 } from 'components/Typography';
import { th } from 'style/theme';

export const ChooseProductContainer = styled(Container)`
  min-height: 880px;
  height: 100vh;
  min-width: 100%;
`;

export const ProductTitle = styled(P)`
  font-family: ${th('fonts.headings')};
  font-size: 24px;
`;

export const ProductDescription = styled(P)`
  font-size: 15px;
  line-height: 1.2;
  text-align: left;
  margin-left: 10px;
`;

export const ProductButtons = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 5%;

  > button {
    margin-top: 60px;
  }
`;

export const Header = styled(H2)`
  margin-left: 5%;
  position: relative;
  z-index: 1;
`;

export const Subheader = styled(P)`
  margin-top: 10px;
  margin-left: 5%;
  position: relative;
  z-index: 1;
`;
